import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryLevelWarningLessThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.product.validation.inventory-level-warning.less-than-zero-error');
    }
}
